


  import dep0 from "@ember/test-waiters/-embroider-implicit-modules.js";
  import dep1 from "@embroider/router/-embroider-implicit-modules.js";
  import dep2 from "@universal-ember/docs-support/-embroider-implicit-modules.js";
  import dep3 from "@universal-ember/table/-embroider-implicit-modules.js";
  import dep4 from "ember-modifier/-embroider-implicit-modules.js";
  import dep5 from "ember-primitives/-embroider-implicit-modules.js";
  import dep6 from "ember-repl/-embroider-implicit-modules.js";
  import dep7 from "ember-resources/-embroider-implicit-modules.js";
  import dep8 from "kolay/-embroider-implicit-modules.js";
  import dep9 from "reactiveweb/-embroider-implicit-modules.js";
  import dep10 from "tracked-built-ins/-embroider-implicit-modules.js";
  import dep11 from "@ember/test-helpers/-embroider-implicit-modules.js";
  import dep12 from "@glimmer/component/-embroider-implicit-modules.js";
  import dep13 from "ember-page-title/-embroider-implicit-modules.js";
  import dep14 from "ember-qunit/-embroider-implicit-modules.js";
  import dep15 from "ember-source/-embroider-implicit-modules.js";
  import dep16 from "@ember/optional-features/-embroider-implicit-modules.js";
  import dep17 from "@embroider/macros/-embroider-implicit-modules.js";
  import dep18 from "ember-auto-import/-embroider-implicit-modules.js";
  import dep19 from "@html-next/vertical-collection/-embroider-implicit-modules.js";
  import dep20 from "ember-resize-observer-service/-embroider-implicit-modules.js";
  import dep21 from "qunit-dom/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
    dep6,
    dep7,
    dep8,
    dep9,
    dep10,
    dep11,
    dep12,
    dep13,
    dep14,
    dep15,
    dep16,
    dep17,
    dep18,
    dep19,
    dep20,
    dep21,
  {
  }
);
